module.exports = __webpack_public_path__ + "static/media/tr.8feb8d8a.svg";